module.exports = __webpack_public_path__ + "media/5_1.41ed8480.wav";